// extracted by mini-css-extract-plugin
export default {"settingsButton":"styles_settingsButton__L-Nns","titleGame":"styles_titleGame__2NShB"};